import { render } from "./CardComponent.vue?vue&type=template&id=1ded894d&scoped=true"
import script from "./CardComponent.vue?vue&type=script&lang=js"
export * from "./CardComponent.vue?vue&type=script&lang=js"

import "./CardComponent.vue?vue&type=style&index=0&id=1ded894d&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src298404285/src/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ded894d"],['__file',"src/components/CardComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ded894d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ded894d', __exports__)) {
    console.log('reload')
    api.reload('1ded894d', __exports__)
  }
  
  module.hot.accept("./CardComponent.vue?vue&type=template&id=1ded894d&scoped=true", () => {
    console.log('re-render')
    api.rerender('1ded894d', render)
  })

}


export default __exports__